import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

const ArticleBody = ({ title, article, recommended }) => (
  <>
    <Head>
      <title>{title}</title>
      <meta name="description" content={article.excerpt} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={article.title} />
      <meta property="og:description" content={article.excerpt} />
      <meta property="og:image" content={article.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="900" />
    </Head>
    <div dangerouslySetInnerHTML={{ __html: article.header }} />
    <div dangerouslySetInnerHTML={{ __html: article.content }} />
    {!!recommended && recommended}
  </>
);

ArticleBody.propTypes = {
  article: PropTypes.object.isRequired,
  title: PropTypes.string,
  recommended: PropTypes.array,
};

ArticleBody.defaultProps = {
  title: null,
  recommended: [],
};

export default ArticleBody;
